import { isIntl } from '../react-process-env';
import { IEditorType, SdkModuleName } from './enum';

// export * from '../react-process-env';

/**
 * app_id
 */
export const APP_ID = '7029803307012000000';
export const ImageEditorPath = isIntl ? '/photo-editor/create' : '/editor';
export const UPLOAD_TYPE = 'posters';
/**
 * 客户端编号
 * @deprecated 用户编辑器
 */
export const CLIENT_ID_POSTER = process.env.REACT_APP_CLIENT_ID as string;

/**
 * 客户端编号
 * @deprecated 图片编辑器
 */
export const CLIENT_ID_IMAGE_EDITOR = process.env.REACT_APP_CLIENT_ID_IMAGE_EDITOR as string;

/**
 * 默认语言
 * @deprecated 使用 `process.env.REACT_APP_LANGUAGE` 代替
 */
export const DEFAULT_LANGUAGE = process.env.REACT_APP_LANGUAGE as string;

// 编辑器模式
export const DESIGNER_MODE = 'designer';

/** 内部设计室模式 */
export const INTERNAL_DESIGNER_MODE = 'internal_designer';

/**
 * 用户编辑器
 */
export const USER_MODE = 'user';

export const MT_GID = 'mt_gid';

export const LOCAL_STORAGE_MATERIAL = 'history-material';

// 图片最大大小
export const MAX_IMAGE_FILE_SIZE = 20 * 1024 * 1024;

// 不需要强登录的页面
export const UNLOGIN_PATH = [
    '/ppt',
    '/ppt/',
    '/poster',
    '/poster/',
    '/psd',
    '/psd/',
    '/share',
    '/share/',
    '/design/share',
    '/design/share/',
    `${ImageEditorPath}`,
    `${ImageEditorPath}/`,
    `${ImageEditorPath}/share`,
    `${ImageEditorPath}/share/`,
];

// 不需要强制登录域名
export const UNLOGIN_DOMAIN = ['ppt.designkit.com', 'ppt1.designkit.com', 'ppt2.designkit.com'];

/**
 * 埋点事件，针对sdk，传入不同的模块名称
 */
export const SDK_MODULE_NAME: {
    [key: string]: string;
} = {
    [SdkModuleName.poster]: 'poster-editor-sdk',
    [SdkModuleName.template]: 'template-sdk',
    [SdkModuleName.image]: 'image-editor-sdk',
};

// 黑五
export const isBlackFriday = process.env.REACT_APP_IS_BLACK_FRIDAY ? true : false;

export const channelMap: Record<string, string> = {
    s: 'share',
};

export const fromMap: Record<string, string> = {
    '': 'share',
};

export const editorTypeMap = {
    [IEditorType.imageEditor]: 'ie',
    [IEditorType.posterEditor]: 'pe',
};

export const NEED_NEW_CLIENT_ID_URL = [
    'seal_pie/nested_create.json',
    'seal_pie/nested_sub_add.json',
    'seal_pie/nested_sub_add.json',
    'common/get_upload_token.json',
    'common/get_upload_token.json',
    'seal_pie/sticker_category_list.json',
    'seal_pie/download_font.json',
    'seal_pie/font_list.json',
    'seal_pie_internal/font_list.json',
    'seal_pie_internal/font_category_list.json',
    'seal_pie/download_image.json',
    'seal_pie/image_list.json',
    'seal_pie_internal/category_list.json',
    'seal_pie_internal/font_category_list.json',
    'seal_pie_internal/category_material_list.json',
    'seal_pie_internal/material_list.json',
    'seal_pie_internal/web_init.json',
    'seal_pie/web_init.json',
    'seal_pie/font_category_list.json',
];
